import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { useOpenEditPlaceLevelModal } from '../../../../utils/routes/modals/modalsActions'
import { usePlaceLevelsActionsList } from '../../../../utils/actions/placeLevels/list'
import { usePlaceLevelsState } from '../_load/PlaceLevelsLoader'
import { useRouteParam } from '../../../../utils/routes/helpers/useParam'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../packages/kiti/components/actions/Link'
import Text from '../../../../packages/kiti/components/presentation/Text'

const PlaceLevelsTable = props => {
  const { t } = useTranslation()
  const { placeLevels: data } = usePlaceLevelsState()
  const placeType = useRouteParam('type')
  const canEdit = true // usePlaceLevelsPermission(entity)
  const onEdit = useOpenEditPlaceLevelModal()

  const columns = [
    {
      label: t('name'),
      headerSideContent: <RefetchingIndicator />,
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 4,
      render: (name, record) => (
        <Link onClick={() => (canEdit ? onEdit({ id: record?.id, type: placeType }) : undefined)}>
          <Text>{name}</Text>
        </Link>
      )
    },

    {
      label: t('hierarchy'),
      headerSideContent: <RefetchingIndicator />,
      dataIndex: 'resume',
      sortIndex: 'RESUME',
      flex: 4
    },

    {
      label: t('actions'),
      width: 5,
      render: useRowActionsColumn(usePlaceLevelsActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" {...props} />
}

export default PlaceLevelsTable
